import React from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import type { ButtonProps } from '../components/Button';
import Button from '../components/Button';
import { TopicPrivacy } from '../graphql/generated/graphqlTypes';
import topicPolicyCheck, { TopicPolicyAction } from '../topic/topicPolicyCheck';
import { useAllTopicMap } from '../topic/useAllTopics';
import { createPostPath } from '../utils/url/postPath';
import { usePublicContentPermissions } from '../utils/useAllowPublicContentBy';

interface CreatePostButtonProps extends ButtonProps {
  topicId?: string | null;
}

const CreatePostButton = ({
  children,
  topicId,
  ...props
}: CreatePostButtonProps) => {
  const currentUser = useAppSelector((state) => state.session.user);
  const isLocked =
    useAppSelector((state) => state.session.organization.isLocked) ?? false;
  const { isPermittedToPublicizePost } = usePublicContentPermissions();

  const topicMap = useAllTopicMap({ skip: !topicId });
  const topic = topicId ? topicMap[topicId] : null;

  const canCreatePostInsideTopic =
    !!topic &&
    topicPolicyCheck(TopicPolicyAction.EditPost, topic, currentUser) &&
    (topic.privacy !== TopicPrivacy.Public || isPermittedToPublicizePost);

  return (
    <Button
      {...props}
      to={createPostPath({
        topicId: canCreatePostInsideTopic && topicId ? topicId : undefined,
      })}
      disabled={isLocked}
    >
      {children}
    </Button>
  );
};

export default CreatePostButton;
